import { Link } from "react-router-dom";

import { Dimmer } from "semantic-ui-react";

import { Container, Row, Col } from "kit/grid";
import { Button, Icon } from "kit/ui";
import QueryString from "core/QueryString";

import type { ActiveRouteType } from "../../utils/routeMatcher";

import routesObject from "../../routesObject";

interface AuthenticationErrorProps {
  customerStatus?: string;
  redirectTo?: string;
  activeRoute: ActiveRouteType;
}

function AuthenticationError({
  customerStatus,
  activeRoute,
  redirectTo
}: AuthenticationErrorProps) {

  return (
    <Dimmer inverted active>
      <Container>
        <Row justifyContent="center">
          <Col width={[ 1, 3 / 4 ]}>
            <h4 css={{ color: "#222" }}>
              <Icon size={56} name="exclamation-triangle" />
            </h4>
            <h4 css={{ color: "#222" }}>
              {
                customerStatus ?
                  "No tienes permiso para ver esta página." :
                  "Para acceder a esta página debes iniciar sesión."
              }
            </h4>
            <br />
            <Button
              as={Link}
              to={
                customerStatus ?
                  redirectTo ?? routesObject.home.url :
                  {
                    pathname: routesObject.login.url,
                    search: QueryString.stringify({
                      redirectTo: encodeURIComponent(activeRoute.pathname + activeRoute.search)
                    })
                  }
              }>
              {customerStatus ?
                "Ir a la página de inicio" :
                "Inicia sesión"}
            </Button>
          </Col>
        </Row>
      </Container>
    </Dimmer>
  );
}

export default AuthenticationError;
